import React, { useMemo } from 'react';
import uniqBy from 'lodash/uniqBy';

import Select from 'components/Select';

function SbatGroupSuperBatchSelect({ sbatGroups, ...remainingProps }) {
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const SuperBatchOptions = useMemo(() => {
    const superBatches = [];

    sbatGroups.forEach((sbatGroup) => {
      const options = sbatGroup.super_batch_academy_topics.map((sbat) => ({
        value: sbat.super_batch.id,
        label: sbat.super_batch.name,
      }));
      superBatches.push(...options);
    });

    return uniqBy(superBatches, (obj) => obj.value);
  }, [sbatGroups]);

  return (
    <Select
      isMulti
      styles={_styles}
      placeholder="Select from dropdown"
      options={SuperBatchOptions}
      sbatGroups={sbatGroups}
      {...remainingProps}
    />
  );
}

export default SbatGroupSuperBatchSelect;
